import { ElementType, ComponentProps } from "react";
import classNames from "classnames";
import styles from "./Badge.module.scss";

type BadgeProps = ComponentProps<"span"> & {
	variant?: "shadow" | "outline";
	as?: ElementType;
};

const badgeVariants = {
	shadow: styles["badge--shadow"],
	outline: styles["badge--outline"],
};

export const Badge = ({
	className,
	variant = "shadow",
	as: Component = "span",
	children,
	...props
}: BadgeProps) => {
	return (
		<Component
			className={classNames(styles.badge, badgeVariants[variant], className)}
			{...props}
		>
			{children}
		</Component>
	);
};
